import React, { useSyncExternalStore } from 'react';
import { useDisplaySettings } from '../hooks/useDisplaySettings';
import { Z_INDEX } from '../constants/zIndex';
import { getNativeBrightness, subscribeNativeBrightness } from '../utils/nativeBrightness';

/**
 * DimOverlay — CSS brightness dimming for web/fallback.
 * Renders a semi-transparent black overlay proportional to (100 - brightness).
 * pointer-events: none so it doesn't block interaction.
 * Laag: `Z_INDEX.DIM_OVERLAY` — boven de screensaver, onder de slaapstand, en onder
 * elke melding. Zie constants/zIndex.ts; het getal hoort daar en nergens anders.
 */
export function DimOverlay() {
  const { settings } = useDisplaySettings();
  // Regelt de APK de echte verlichting, dan zou deze laag er nog eens bovenop dimmen.
  const native = useSyncExternalStore(subscribeNativeBrightness, getNativeBrightness);

  if (native || settings.brightness >= 100) return null;

  const alpha = (100 - settings.brightness) / 100;

  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        zIndex: Z_INDEX.DIM_OVERLAY,
        backgroundColor: `rgba(0, 0, 0, ${alpha})`,
        pointerEvents: 'none',
      }}
      aria-hidden="true"
    />
  );
}
